import { AiRoute, LazyPage, RoutinesPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function RoutinesRoute() {
  return (
    <AiRoute>
      <LazyPage>
        <RoutinesPage />
      </LazyPage>
    </AiRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/agent/routines')({
  component: RoutinesRoute,
});
